import React from 'react';

const SvgGe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GE_svg__b" fill="#fff">
        <use xlinkHref="#GE_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M12 8v-9.333h4V8h13.333v4H16v9.333h-4V12H-1.333V8H12z"
        fill="#FF2B37"
        mask="url(#GE_svg__b)"
      />
      <path
        d="M21.6 3.6L21.333 2h1.334L22.4 3.6l1.6-.267v1.334L22.4 4.4l.267 1.6h-1.334l.267-1.6-1.6.267V3.333l1.6.267zM5.6 3.6L5.333 2h1.334L6.4 3.6 8 3.333v1.334L6.4 4.4 6.667 6H5.333L5.6 4.4 4 4.667V3.333l1.6.267zM5.6 15.6L5.333 14h1.334L6.4 15.6l1.6-.267v1.334L6.4 16.4l.267 1.6H5.333l.267-1.6-1.6.267v-1.334l1.6.267zM21.6 15.6l-.267-1.6h1.334l-.267 1.6 1.6-.267v1.334l-1.6-.267.267 1.6h-1.334l.267-1.6-1.6.267v-1.334l1.6.267z"
        fill="#FD0D1B"
        mask="url(#GE_svg__b)"
      />
    </g>
  </svg>
);

export default SvgGe;
